import { render } from "./HistoryQuestions.vue?vue&type=template&id=9a722764"
import script from "./HistoryQuestions.vue?vue&type=script&lang=js"
export * from "./HistoryQuestions.vue?vue&type=script&lang=js"

import exportComponent from "D:\\CTL-Project\\ChatBotSHLX\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__